import {
  formatPercentageValue,
  formatNormalNumber,
  createKpiTileItem,
} from '../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { totalUser, totalUsersPercentageDelta } =
      data?.getUserAdoptionScorecard?.data || {};

    return createKpiTileItem(
      'Total Users',
      formatNormalNumber(totalUser),
      totalUsersPercentageDelta
        ? {
            isPositiveValue: totalUsersPercentageDelta >= 0,
            text: formatPercentageValue(Math.abs(totalUsersPercentageDelta)),
            sideLabel: '',
            showArrow: Number(totalUsersPercentageDelta) !== 0,
          }
        : null
    );
  },
};
